import React from "react";

import Table from "components/Table";
import {statusGoalsList} from "utils/status";
import {TableList} from "../TableList";

export const ListGoals = ({selected}) => {

    return (
        <>
            {selected ?
                <Table
                    selected={selected.title}
                    status={selected.status}
                    param="goals"
                />
                :
                <>
                    {statusGoalsList.map((item, index) => {

                        let divider = false

                        if(index > 0) {
                            if (item.language !== statusGoalsList[index-1].language) {
                                divider = true
                            }
                        }

                        return(
                            <React.Fragment key={index}>
                                { divider && <br /> }
                                <TableList
                                    status={item.status}
                                    label={item.label}
                                    language={item.language}
                                />
                            </React.Fragment>
                        )
                    })}

                    <br />

                    <TableList
                        label="Oculdados"
                        trashed={true}
                    />
                </>
            }
        </>
    );
}
